import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter-indicator",
  "use": "filter-indicator-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"filter-indicator\"><path fill-rule=\"evenodd\" d=\"M14 18v-2h-4v2h4ZM3 8h18V6H3v2Zm15 5v-2H6v2h12Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol